import { render, staticRenderFns } from "./ReservationColumnsTab.vue?vue&type=template&id=fb233aca&scoped=true&"
import script from "./ReservationColumnsTab.vue?vue&type=script&lang=js&"
export * from "./ReservationColumnsTab.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumnsTab.vue?vue&type=style&index=0&id=fb233aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb233aca",
  null
  
)

export default component.exports